import PubSub from "underpub-js";
import tippy from 'tippy.js';
import 'tippy.js/animations/shift-toward.css';

var NavigationBarItem = function (options) {

  this.options = {
    $el: false,
    baseClass: 'atom-NavigationBarItem',
  };

  $.extend(true, this.options, options);

};

NavigationBarItem.prototype.init = function () {

  var self = this;

  self.$heading = self.options.$el.find(`.${self.options.baseClass}__heading`);
  self.$items = self.options.$el.find(`.${self.options.baseClass}__items`);

  if (self.$items.length) {

    tippy(self.$heading[0], {
      content: self.$items[0],
      animation: 'shift-toward',
      arrow: true,
      inertia: true,
      theme: "navigationBar-menuItem",
      maxWidth: "none",
      interactive: true,
      zIndex: 200,
      offset: [0, 20],
      duration: [400, 200]
    });

  }
};

export default NavigationBarItem;